import React, { useState, useEffect } from "react";
import { Steps, Affix } from "antd";

const CustomStepProgress = ({ steps, handleScreen }) => {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    setActiveStep(handleScreen);
  }, [handleScreen]);

  useEffect(() => {
    setActiveStep(handleScreen);
  }, [handleScreen]);

  return (
    <>
      <div className="main-steps">
        {/* <Affix offsetTop={30 + 45}> */}
        <Steps
          current={activeStep}
          className="steps ant-steps-horizontal ant-steps-label-vertical"
          labelPlacement="vertical"
          // onChange={handleOnChange}
        >
          {steps.map((item, idx) => (
            <Steps.Step key={idx} title={item.title} icon={<item.icon />} />
          ))}
        </Steps>
        {/* </Affix> */}
        {steps.map((item, idx) => (
          <>
            <div
              key={idx}
              className={`steps-content  ${
                item.step !== activeStep + 1 && "hidden"
              }`}
            >
              {item.content}
            </div>
          </>
        ))}
      </div>
    </>
  );
};

export { CustomStepProgress };
